module.exports = __webpack_public_path__ + "img/plastics-img-4.e64f730b.png";